const commaVerification = (val: string, comma = true): boolean => {
  let re = /^[a-zA-Z0-9]+$/;
  if (comma) {
    re = /^[a-zA-Z0-9]+([,][a-zA-Z0-9]+)*[,]?$/;
  }
  return re.test(val);
};
export default commaVerification;
export const withComma = '/^[a-zA-Z0-9]+([,][a-zA-Z0-9]+)*[,]?$/';
export const noComma = '/^[a-zA-Z0-9]+$/';
// a regex that verify if many alphanumeric characters separated by a comma
// Language: typescript
